// extracted by mini-css-extract-plugin
export default {"text_description":"CardProductLanding-module__text_description__cB6my"};